import React from 'react';
import { AccountantAccountSwitcherMode, ClientData } from './types';
import { AccountantClientItem } from './AccountantClientItem';
import { useStore } from '../../../../store';

interface IProps {
    clients: ClientData[];
    type?: string;
    mode: AccountantAccountSwitcherMode;
    isLoading: boolean;
    onAcceptInvitationClick?: (client: ClientData) => void;
    onClientSelection?: (client: ClientData) => void;
}

export const AccountantClientsList = ({
  clients, type, mode, isLoading, onAcceptInvitationClick, onClientSelection,
}: IProps) => {
  const { customerId } = useStore(state => state.user);

  return type === 'PENDING' ? (
    <div className='flex flex-col border-b border-1 border-bw03 mb-[16px]'>
      {clients.map((clientData) => (
        <AccountantClientItem
          client={clientData}
          isLoading={isLoading}
          itemMode={mode}
          onAcceptInvitationClick={() => { if (onAcceptInvitationClick) onAcceptInvitationClick(clientData); }}
        />
      ))}
    </div>
  ) : (
    <>
      {clients.map((clientData) => (
        <AccountantClientItem
          client={clientData}
          isChecked={clientData.clientId === customerId}
          itemMode={mode}
          onSelectClient={() => { if (onClientSelection) onClientSelection(clientData); }}
        />
      ))}
    </>
  );
};
